import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { viewPDF } from "../../../../../utils/viewPDF";
import ErrorModal from "../../../../../utils/ErrorModal";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import axios from "axios";
import { uploadFile } from "../../../../../utils/uploadToAzure";

const Step3 = ({
  sra,
  setSra,
  setStep,
  storedUser,
  fileNames,
  setFileNames,
}) => {
  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState({
    attachment1: false,
    attachment2: false,
    attachment3: false,
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const orgId = JSON.parse(localStorage.getItem("org"));

  const setFieldLoading = (field, isLoading) => {
    setUploading((prev) => ({
      ...prev,
      [field]: isLoading,
    }));
  };

  const setFilenames = (field, filename) => {
    setFileNames((prev) => ({
      ...prev,
      [field + "Filename"]: filename,
    }));
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const field = e.target.name;

    if (!file) return;

    setFieldLoading(field, true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await uploadFile(
        file,
        orgId,
        "Vendor-Advance",
        sra.vendorAdvanceId,
        storedUser
      );
      setSra({ ...sra, [e.target.name]: res });
      setFilenames(field, file.name);
    } catch (error) {
      console.log(error);
    } finally {
      setFieldLoading(e.target.name, false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.attachment1)) {
      newErrors.attachment1 = "Attachment 1 is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  const handleRemoveAttachment = (field) => {
    setSra((prev) => ({
      ...prev,
      [field]: null,
    }));

    setFileNames((prev) => ({
      ...prev,
      [field + "Filename"]: "",
    }));
  };
  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Vendor Advance</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "60%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Attachments</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="attachment1">
              Attachment 1 <span style={{ color: "#FF0000" }}>*</span>
              <div
                className={`input-file ${errors.attachment1 && "input-error"}`}
              >
                <input
                  type="file"
                  id="attachment1"
                  name="attachment1"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.attachment1Filename || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            <Box>
              {errors.attachment1 && (
                <p className="error">{errors.attachment1}</p>
              )}
              {uploading.attachment1 && (
                <span style={{ fontSize: "12px" }}>
                  Uploading File... <CircularProgress size="30px" />
                </span>
              )}
              {sra && sra.attachment1 && (
                <>
                  <Button
                    sx={{
                      margin: "-6% 0 0 0 !important",
                      width: "max-content !important",
                      fontSize: "12px !important",
                      textDecoration: "underline",
                      textAlign: "start",
                    }}
                    onClick={() => viewPDF(sra.attachment1, storedUser)}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "inline-block",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {fileNames.attachment1Filename}
                    </Box>
                  </Button>
                  <Button
                    className="btn-reject"
                    sx={{ display: "block", fontSize: "12px", ml: 1 }}
                    onClick={() => handleRemoveAttachment("attachment1")}
                  >
                    Remove
                  </Button>
                </>
              )}
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="attachment2">
              Attachment 2
              <div
                className={`input-file ${errors.attachment2 && "input-error"}`}
              >
                <input
                  type="file"
                  id="attachment2"
                  name="attachment2"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.attachment2Filename || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            <Box>
              {errors.attachment2 && (
                <p className="error">{errors.attachment2}</p>
              )}
              {uploading.attachment2 && (
                <span style={{ fontSize: "12px" }}>
                  Uploading File... <CircularProgress size="30px" />
                </span>
              )}
              {sra && sra.attachment2 && (
                <>
                  <Button
                    sx={{
                      margin: "-6% 0 0 0 !important",
                      width: "max-content !important",
                      fontSize: "12px !important",
                      textDecoration: "underline",
                      textAlign: "start",
                    }}
                    onClick={() => viewPDF(sra.attachment2, storedUser)}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "inline-block",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {fileNames.attachment2Filename}
                    </Box>
                  </Button>
                  <Button
                    className="btn-reject"
                    sx={{ display: "block", fontSize: "12px", ml: 1 }}
                    onClick={() => handleRemoveAttachment("attachment2")}
                  >
                    Remove
                  </Button>
                </>
              )}
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="attachment3">
              Attachment 3
              <div
                className={`input-file ${errors.attachment3 && "input-error"}`}
              >
                <input
                  type="file"
                  id="attachment3"
                  name="attachment3"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.attachment3Filename || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            <Box>
              {errors.attachment3 && (
                <p className="error">{errors.attachment3}</p>
              )}
              {uploading.attachment3 && (
                <span style={{ fontSize: "12px" }}>
                  Uploading File... <CircularProgress size="30px" />
                </span>
              )}
              {sra && sra.attachment3 && (
                <>
                  <Button
                    sx={{
                      margin: "-6% 0 0 0 !important",
                      width: "max-content !important",
                      fontSize: "12px !important",
                      textDecoration: "underline",
                      textAlign: "start",
                    }}
                    onClick={() => viewPDF(sra.attachment3, storedUser)}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "inline-block",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {fileNames.attachment3Filename}
                    </Box>
                  </Button>
                  <Button
                    className="btn-reject"
                    sx={{ display: "block", fontSize: "12px", ml: 1 }}
                    onClick={() => handleRemoveAttachment("attachment3")}
                  >
                    Remove
                  </Button>
                </>
              )}
            </Box>
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>

      <ErrorModal
        open={errorOpen}
        handleClose={() => setErrorOpen(false)}
        msg={errorMsg}
      />
    </div>
  );
};

export default Step3;
